import React, { FunctionComponent } from "react";
import styles from "../css/Section9.module.css";

import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { AskQuestionEng } from "../../svg_groups/ask_question_eng";
import { AskQuestionRo } from "../../svg_groups/ask_question_ro";

const Section9 = () => {
  const language = useSelector((state: any) => state.language.value);
  const navigate = useNavigate();

  const handleScroll = () => {
    navigate("/preview");
    setTimeout(() => {
      const element = document.querySelector(".mainContent");
      element?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.element1}>
        <div className={styles.header}>
          <span className={styles.title}>
            {" "}
            {language === "RO" && "Întrebări frecvente"}
            {language === "EN" && "Frequently Asked Questions"}
          </span>
          <span className={styles.title1}>
            {" "}
            {language === "RO" && "Întrebări frecvente"}
            {language === "EN" && "Frequently Asked Questions"}
          </span>
        </div>

        <div className={styles.questionMarkContainerContainer}>
          <div className={styles.questionMarkContainer}>
            {language === "EN" ? <AskQuestionEng /> : <AskQuestionRo />}
          </div>

          <div className={styles.photoBook}>
            <img src="" style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
      </div>
      <div className={styles.element2}>
        <Accordion
          sx={{
            background: "transparent",
            boxShadow: "unset",
            // width: "55%",
            borderBottom: "1px solid #C4B57C",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography component="span" color="#517059">
              {language === "RO" && "Pot comanda cartea cu autograf?"}
              {language === "EN" && "Can I order a signed copy of the book?"}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ color: "#8F8F8F" }}>
            {language === "RO" &&
              "Desigur! Pentru aceasta lasă un mesaj în căsuța cu 'Solicitări adiționale' când adaugi cartea în coș. Important, cartea cu autograf poate fi comandată doar de pe site-ul oficial. Cărțile comandate pe Amazon sunt livrate fără autograf."}
            {language === "EN" &&
              "Of course! To do so, simply leave a message in the 'Additional Requests' box when adding the book to your cart. Please note, signed copies can only be ordered through the official website. Books ordered on Amazon will be delivered without a signature."}
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{
            background: "transparent",
            boxShadow: "unset",
            // width: "55%",
            borderBottom: "1px solid #C4B57C",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <Typography component="span" color="#517059">
              {language === "RO" && "Câte pagini are cartea?"}
              {language === "EN" && "How many pages does the book have?"}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ color: "#8F8F8F" }}>
            {language === "RO" &&
              "Cartea are x pagini structurate în X capitole. Cei care au avut ocazia să o răsfoiască spun că 'e miere pe suflet și se citește foarte ușor'."}
            {language === "EN" &&
              "The book contains X pages, structured into VII chapters. Those who have had the chance to browse it say, 'It`s like honey for the soul and reads very easily.'"}
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{
            background: "transparent",
            boxShadow: "unset",
            // width: "55%",
            borderBottom: "1px solid #C4B57C",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            <Typography component="span" color="#517059">
              {language === "RO" &&
                "Pentru ce vârste este potrivită această carte?"}
              {language === "EN" && "What age group is this book suitable for?"}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ color: "#8F8F8F" }}>
            {language === "RO" &&
              "Această carte este potrivită oricărei persoane care are nevoie de inspirație, de un exemplu că lucrurile vor evolua și totul se va realiza dacă ai curaj să visezi, chiar și în cele mai grele perioade din viață. Dăruiește această carte celui care caută libertatea, indiferent de vârstă."}

            {language === "EN" &&
              "This book is suitable for anyone in need of inspiration, someone looking for proof that things will evolve and everything will fall into place if you dare to dream, even in the toughest times. Give this book to someone who is seeking freedom, no matter their age."}
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{
            background: "transparent",
            boxShadow: "unset",
            // width: "55%",
            borderBottom: "1px solid #C4B57C",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            <Typography component="span" color="#517059">
              {language === "RO" &&
                "Este această carte potrivită pentru bărbați?"}
              {language === "EN" && " Is this book suitable for men?"}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ color: "#8F8F8F" }}>
            {language === "RO" &&
              "Da, este potrivită pentru suflete de orice gen."}
            {language === "EN" &&
              "Yes, it is suitable for souls of any gender."}
          </AccordionDetails>
        </Accordion>
        <Accordion
          sx={{
            background: "transparent",
            boxShadow: "unset",
            // width: "55%",
            borderBottom: "1px solid #C4B57C",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            <Typography component="span" color="#517059">
              {language === "RO" && "Cum pot comanda cartea?"}
              {language === "EN" && "How can I order the book?"}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ color: "#8F8F8F" }}>
            {language === "RO" && (
              <>
                Cartea are diverse formate și există mai multe opțiuni de a o
                comanda:
                <br />
                <br />
                1. Pe site-ul oficial:{" "}
                <span
                  onClick={handleScroll}
                  style={{
                    cursor: "pointer",
                    color: "#517059",
                    textDecoration: "underline",
                  }}
                >
                  AICI
                </span>
                <br />
                <br />
                2. Amazon
                <br />
                format: <Link to="#">PDF</Link> | <Link to="#">Fizic</Link> |{" "}
                <Link to="#">Audio</Link>{" "}
              </>
            )}

            {language === "EN" && (
              <>
                The book is available in several formats and there are multiple
                ways to order it:
                <br />
                <br />
                1. Via the official website:{" "}
                <span
                  onClick={handleScroll}
                  style={{
                    cursor: "pointer",
                    color: "#517059",
                    textDecoration: "underline",
                  }}
                >
                  HERE
                </span>
                <br />
                <br />
                2. On amazon
                <br />
                Formats available: <Link to="#">PDF</Link> |{" "}
                <Link to="#">Physical</Link> | <Link to="#">Audio</Link>{" "}
              </>
            )}
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default Section9;
